<template>
  <div
    v-tinymce="options"
    :key="renderKey"
    @mce-change="(introduction) => offerSectionSet({ introduction: introduction })"
    @mce-dirty="() => $emit('dirty')">
    <div v-if="offerSections.introduction" v-html="offerSections.introduction"></div>
    <b-card v-else>
      <div>
        <p class="mb-4">{{ salutation }}</p>
        <p>{{ $t('introduction.thanks') }}</p>
        <p>
          {{ $t(offer.isIndividualTraining ? 'introduction.trainingIndividual' : 'introduction.trainingTeam', { title: offer && offer.title ? offer.title : seminarTitle }) }}
          <span v-if="!isOpenSeminar">{{ $t('introduction.companyFocus') }}</span>
        </p>
        <p>{{ $t('introduction.partner') }}</p>
        <p>{{ $t('introduction.offerBelow') }}</p>
        <p v-if="!isOpenSeminar">{{ $t('introduction.agenda') }}</p>
        <p>
          {{ $t('introduction.questions') }} <br /><span
            v-if="isOpenSeminar"
            class="font-semibold"
            >0221 82 80 90</span
          ><span v-else>0221/8280915</span>{{ $t('introduction.thanksClosing') }}
        </p>
        <p>
          {{ $t('introduction.regards') }}
          <span v-if="isOpenSeminar">
            <span v-if="customerCity && customerCity !== 'Köln'"> {{ $t('introduction.toCity', { city: customerCity }) }}</span>
            <span v-else> {{ $t('introduction.fromCologne') }}</span>
          </span>
        </p>
        <p class="mt-4">{{ contactName }}</p>
        <p>GFU Cyrus AG</p>
      </div>
      <div v-if="offer.showCustomerReviews" class="cr-ratings-ps">
        <p v-if="companyRating.length != 0">
          P.S.:
          <span v-if="authorNameAmount == 1">{{ $t('introduction.colleagueSingular') }} </span>
          <span v-for="(author, index) in authorNames" :key="index">
            <span v-if="companyRatingAmount > 3">
              <span v-if="index > 0">, </span>
            </span>
            <span v-if="companyRatingAmount < 4">
              <span v-if="index > 0 && index != authorNameAmount - 1">, </span>
              <span v-if="index > 0 && index == authorNameAmount - 1"> {{ $t('introduction.and') }} </span>
            </span>
            <strong>{{ author }}</strong>
          </span>
          <span v-if="companyRatingAmount < 4">
            <span v-if="authorNameAmount > 1"> {{ $t('introduction.colleaguesVisitedPlural') }}</span>
            <span v-if="authorNameAmount == 1"> {{ $t('introduction.colleaguesVisitedSingular') }}</span>
          </span>
          <span v-if="companyRatingAmount > 4">
            {{ $t('introduction.furtherColleagues', { count: companyRatingAmount - 3 }) }}</span
          >
          <span v-if="companyRatingAmount == 4">
            {{ $t('introduction.oneFurtherColleague') }}</span
          >
        </p>
        <p>
          <a v-if="companyRating.length != 0" href="#customerReviews">
            <strong>
              <i class="material-icons" style="vertical-align: text-bottom">chevron_right</i>
              {{ $t('introduction.toColleagueReviews') }}
            </strong>
          </a>
        </p>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import placeholder from "./placeholder";
import { buildOfferSalutation } from "../../misc/OfferSalutation";

export default {
  name: "Introduction",
  mixins: [placeholder],
  props: {
    options: Object,
  },
  data() {
    return {
      renderKey: 0,
    };
  },
  computed: {
    ...mapGetters(["contact", "company", "seminar", "employee", "offerSections", "companyRating", "offer"]),
    salutation: function () {
      if (!this.contact && !this.salutationLetter) return this.placeholder;
      return buildOfferSalutation(
        this.contact,
        this.offer.language,
        this.salutationLetter,
      );
    },
    salutationLetter: function () {
      return this.offer && this.offer.salutation;
    },
    customerName: function () {
      return this.contact ? this.contact.lastName : this.placeholder;
    },
    seminarTitle: function () {
      return this.seminar ? this.seminar.title : this.placeholder;
    },
    customerCity: function () {
      return this.company ? this.company.city : this.placeholder;
    },
    contactName: function () {
      return this.employee ? this.employee.firstName + " " + this.employee.lastName : this.placeholder;
    },
    authorNames() {
      // console.log('companyRating', this.companyRating);
      return this.companyRating
        ? this.companyRating
            .map((rating) => rating.author.name)
            .filter((rating) => rating) //filter has rating
            .filter((item, index, array) => array.indexOf(item) === index) //filter duplicate names
            .slice(0, 3)
        : null;
    },
    companyRatingAmount() {
      return this.companyRating ? this.companyRating.length : null;
    },
    authorNameAmount() {
      // console.log('authorNames', this.authorNames)
      return this.authorNames ? this.authorNames.length : null;
    },
    isOpenSeminar() {
      return this.offer && parseInt(this.offer.offerType_id) === 4;
    },
  },
  mounted() {
    setTimeout(() => {
      this.attachEventListerLink();
    }, 300);
  },
  methods: {
    ...mapMutations(["offerSectionSet"]),
    attachEventListerLink() {
      const link =
        this.$el.querySelector('a[href="#customerReviews"]') || this.$el.querySelector('a[href="#companyRatings"]');
      if (link) {
        link.addEventListener("click", this.scrollToCompanyReviews);
      }
    },
    scrollToCompanyReviews(e) {
      e.preventDefault();
      const el = document.getElementById("customerReviews");
      if (!el) return;
      window.scrollTo({
        behavior: "smooth",
        top: el.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 90,
      });
    },
  },
  watch: {
    offer: function () {
      this.renderKey++;
    },
    customer: function () {
      this.renderKey++;
    },
    seminar: function () {
      this.renderKey++;
    },
    employee: function () {
      this.renderKey++;
    },
    companyRating: function () {
      this.renderKey++;
    },

    offerSections: {
      handler: function (newVal, oldVal) {
        console.log("offerSections changed", newVal);
      },
    },
  },
};
</script>

<style scoped>
.font-semibold {
  font-weight: 500;
}
</style>
